<template>
  <div class="div-scroll">
    <el-card class="box-table">
      <div slot="header" class="btn-group">
        <div></div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
        @showDetail="goto"
      >
        <template slot="status" slot-scope="scope">
          <span>{{ statusList[Number(scope.row.status)] }}</span>
        </template>
      </c-table>
    </el-card>
  </div>
</template>

<script>
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import Configs from "../data/train";
import MPage from "@/mixins/MPage.js";
let mPage = MPage({
  pagePath: "/welcome-live/green/apply/listPage?status=4",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
export default {
  name: "",
  components: {
    CTable,
    TableBtns,
  },
  mixins: [mPage],
  data() {
    let { tableColumnsReviewed } = Configs(this);
    return {
      SUCCESS_CODE: "",
      tableColumns: tableColumnsReviewed,
      statusList: ["未完成", "已完成", "驳回", "审核中", "审核通过"],
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
  },
  mounted() {},
  methods: {
    selectionChange() {},
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    goto(data) {
      // this.$router.push("/welcome/teacher/predicted/greenDetail/handled/" + data.id)
      this.$router.push({path:"/welcome/teacher/predicted/greenDetail",query:{id:data.id,type:'handled'}})
    }
  },
};
</script>
